import React, { useContext, useState } from "react";
import {
    Card,
    IconContainer,
    Title,
    Description,
    LearnMore,
    PlusIcon,
    AddGatewayButton,
} from "./AddGatewayCard.styles";
import { ApplicationContext } from "../../../../../components/ApplicationProvider";
import PlusIconImage from "../../../../../images/gateways/plus.svg";
import AddGatewayModal from "../../AddGatewayModal/AddGatewayModal";
import { CloudAccessType } from "../../../../../graphql";

type AddGatewayCardProps = {
    setCheckIfPollingTrue: (setProperty: boolean) => void;
    setNewThingName: (setThingName: string) => void;
    onSuccessfullRequest: () => void;
    printerSerial?: string;
    cloudAccessType?: CloudAccessType;
};

const AddGatewayCard: React.FC<AddGatewayCardProps> = ({
    setCheckIfPollingTrue,
    setNewThingName,
    onSuccessfullRequest,
    printerSerial,
    cloudAccessType,
}) => {
    const { t } = useContext(ApplicationContext);
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Card data-testid="add-gateway-card">
                <AddGatewayButton
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                    data-testid="add-gateway-card-button"
                >
                    <IconContainer data-testid="add-gateway-plus-icon">
                        <PlusIcon src={PlusIconImage} alt="" />
                    </IconContainer>

                    <Title data-testid="add-gateway-card-title">
                        {t("devices.gateways.add_gateway_card.title")}
                    </Title>
                </AddGatewayButton>

                <Description data-testid="add-gateway-card-description">
                    {t("devices.gateways.add_gateway_card.description")}
                </Description>

                <LearnMore
                    href="https://support.stratasys.com/en"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="add-gateway-card-learn-more"
                >
                    {t("devices.gateways.add_gateway_card.learn_about")}
                </LearnMore>
            </Card>

            <AddGatewayModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                setCheckIfPollingTrue={setCheckIfPollingTrue}
                setNewThingName={setNewThingName}
                onSuccessfullRequest={onSuccessfullRequest}
                printerSerial={printerSerial}
                cloudAccessType={cloudAccessType}
            />
        </>
    );
};

export default AddGatewayCard;
